var map = {
	"./logo-OST2-m.png": 594,
	"./logo-OST2.png": 595,
	"./logo-Sync2-Cloud-m.png": 596,
	"./logo-Sync2-Cloud.png": 597,
	"./logo-duplicate-killer-m.png": 598,
	"./logo-duplicate-killer.png": 599,
	"./logo-ostpstviewer-m.png": 600,
	"./logo-ostpstviewer.png": 601,
	"./logo-outlook-duplicate-remover-m.png": 602,
	"./logo-outlook-duplicate-remover.png": 603,
	"./logo-vcard-m.png": 604,
	"./logo-vcard.png": 605,
	"./logo_SPB.png": 606,
	"./undefined.png": 607
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 593;